import { FC } from "react";
import { NodeProps } from "reactflow";
import { StepDto, StepExecutionDto } from "../../../../dtos";
import { NodeType } from "../NodeType";
import { NodeTypes } from "../utils";
import { IStepEditModalProps, IStepExecutionDetailsProps } from "../types";
import { AutomationNodeEditForm, AutomationNodeExecutionDetails, AutomationNodeLibraryListItem, AutomationPlayViewerNode } from "./Components";

export class AutomationNodeType extends NodeType {
    public readonly nodeType: string = NodeTypes.AUTOMATION;
    
    public readonly PlayViewerNode: FC<NodeProps<StepDto | StepExecutionDto>> = AutomationPlayViewerNode;
    public readonly EditModalContent?: FC<IStepEditModalProps> = AutomationNodeEditForm;
    public readonly ExecutionDetailsContent?: FC<IStepExecutionDetailsProps> = AutomationNodeExecutionDetails;
    public readonly NodeLibraryListItem: FC = AutomationNodeLibraryListItem;
}